const Dashboard = () => {
    return <h1 className="text-2xl font-normal ">Dashboard</h1>;
  };
  
  export default Dashboard;
  